
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function NonHealingUlcer(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Non healing ulcer "}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Chronic ulcers or non-healing ulcers are defined as <b>spontaneous or
                                    traumatic lesions,</b> typically in lower extremities that are
                                    unresponsive to initial therapy or that persist despite appropriate care
                                    and do not proceed towards healing in a defined time period with an
                                    underlying etiology that may be related to systemic</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Non-healing-ulcer/1.png")} alt="Non-healing-ulcer" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>Pain around the wound that doesn’t improve or seems to get worse.</p>
                                <p>Dark or blue colour around the edges of the wound.</p>
                                <p>Wound that seems to be weeping, draining or leaking more.</p>
                                <p>Redness or swelling that spreads away from the wound.</p>
                                <p>The wound starts to smell bad.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Ulcer_(dermatology)">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default NonHealingUlcer;